import {NavLink} from "react-router-dom";
import logo from "../../images/logo.png";
import "./style.css"

function Navbar() {
    const links = [
        {label: "Home", href: "/"},
        {label: "Pricing", href: "http://www.cabbagesoft.com/inventro", external: true},
        {label: "About Us", href: "http://www.cabbagesoft.com/about", external: true},
        {label: "Blog", href: "/blog"},
        {label: "Careers", href: "/careers"},
        {label: "FAQ", href: "/faq"},
        {label: "Login", href: "/login", class: "btn btn-primary btn-primary-custom ms-sm-3 ms-0 w-100"},
    ];

    return (
        <>
            <nav className="navbar navbar-expand-md bg-white" id="navbar">
                <div className="container">
                    <a className="navbar-brand" href="/">
                        <img src={logo} alt="Inventro Logo" width="150" height="50" />
                    </a>
                    <button className="navbar-toggler border-0" type="button" data-bs-toggle="collapse"
                            data-bs-target="#navbarContent">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarContent">
                        <ul className="navbar-nav ms-auto">
                            {links.map((link, i) => (
                                <li key={"nav_" + i} className="nav-item px-1 text-center">
                                    {link.external ? (
                                        <a
                                            href={link.href}
                                            className={link.class || "nav-link"}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            {link.label}
                                        </a>
                                    ) : (
                                        <NavLink
                                            to={link.href}
                                            className={({ isActive }) =>
                                                (link.class || "nav-link") +
                                                (isActive ? " active text-primary" : "")
                                            }
                                        >
                                            {link.label}
                                        </NavLink>
                                    )}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </nav>
        </>
    );
}

export default Navbar;
